export const CAMPAIGN = {
  ROUTES: {
    MAIN: 'campaign',
    FORM: 'campaign/:venueId',
    CAMP_FORM: 'campaign/:venueId/:campaignId',
  },
};
